/* Kit UI — comportamento comum das secções kit-*.
   1) aparecer ao rolar (.kit-reveal → .is-in) · 2) passos «Paso 1/2/3…» · 3) aviso «añadido» + bolha do carrinho · 4) resumo por passo + barra fixa no telemóvel.
   Pode ser incluído por várias secções na mesma página: só corre uma vez. */
(function () {
  if (window.KitUI) return;
  var KitUI = window.KitUI = {};
  var raizLoja = function () { return window.Shopify && Shopify.routes ? Shopify.routes.root : '/'; };
  var pronto = function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fn(); }); else fn(); document.addEventListener('shopify:section:load', function (e) { fn(e.target); }); };

  /* 1) aparecer ao rolar; [data-kit-stagger] dá atraso em escada aos filhos */
  KitUI.reveal = function (raiz) {
    raiz = raiz || document;
    var els = [].slice.call(raiz.querySelectorAll('.kit-reveal:not(.is-in)'));
    if (!els.length) return;
    raiz.querySelectorAll('[data-kit-stagger]').forEach(function (g) {
      [].slice.call(g.querySelectorAll('.kit-reveal')).forEach(function (el, i) { el.style.setProperty('--kit-d', Math.min(i, 8) * 0.07 + 's'); });
    });
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  };

  /* 2) passos: [data-kit-pasos] > .kit-paso[data-titulo][data-ayuda] → um passo de cada vez.
     Bolinhas numeradas clicáveis, «Paso N de M», título, instruções, Anterior/Siguiente, total ([data-total]) à vista.
     Textos alteráveis com data-txt-paso / data-txt-de / data-txt-ant / data-txt-sig / data-txt-fin / data-txt-total na caixa. Sem JS fica tudo aberto. */
  KitUI.pasos = function (raiz) {
    (raiz || document).querySelectorAll('[data-kit-pasos]:not(.is-ready)').forEach(function (box) {
      var ps = [].filter.call(box.children, function (c) { return c.classList.contains('kit-paso'); }), n = ps.length, at = 0;
      if (n < 2) return;
      var T = function (k, def) { return box.getAttribute('data-txt-' + k) || def; };
      box.classList.add('is-ready');
      var cab = document.createElement('div'); cab.className = 'kit-pasos__cab';
      cab.innerHTML = '<p class="kit-pasos__n" aria-live="polite"></p><h3 class="kit-pasos__tit"></h3><p class="kit-pasos__ayuda"></p>';
      var dots = document.createElement('ol'); dots.className = 'kit-pasos__dots';
      ps.forEach(function (p, i) {
        var li = document.createElement('li'), b = document.createElement('button');
        b.type = 'button'; b.dataset.i = i; b.textContent = i + 1; b.setAttribute('aria-label', T('paso', 'Paso') + ' ' + (i + 1) + ': ' + (p.dataset.titulo || ''));
        li.appendChild(b); dots.appendChild(li);
      });
      var fila = document.createElement('div'); fila.className = 'kit-pasos__fila'; fila.appendChild(dots);
      var pe = document.createElement('div'); pe.className = 'kit-pasos__nav';
      pe.innerHTML = '<button type="button" class="kit-pasos__ant"></button><span class="kit-pasos__tot"></span><button type="button" class="button kit-pasos__sig"></button>';
      pe.querySelector('.kit-pasos__ant').textContent = '← ' + T('ant', 'Anterior');
      box.insertBefore(fila, ps[0]); box.insertBefore(cab, ps[0]); box.appendChild(pe);

      // vista fixa opcional ([data-kit-visual] na secção): a fila de passos fica logo por baixo dela no telemóvel/tablet
      var sec = box.closest('section') || box.parentElement, vis = sec && sec.querySelector('[data-kit-visual]');
      if (vis && window.ResizeObserver) {
        var medir = function () { var fixa = getComputedStyle(vis).position === 'sticky' && innerWidth < 990; sec.style.setProperty('--kit-vis-h', (fixa ? vis.offsetHeight : 0) + 'px'); };
        new ResizeObserver(medir).observe(vis); addEventListener('resize', medir); medir();
      }

      var tot = sec.querySelector('[data-total]'), te = pe.querySelector('.kit-pasos__tot'), sig = pe.querySelector('.kit-pasos__sig');
      function espelho() { var t = tot && tot.textContent.trim(); te.textContent = t && t !== '—' ? T('total', 'Total') + ' ' + t : ''; }
      if (tot && window.MutationObserver) new MutationObserver(espelho).observe(tot, { childList: true, characterData: true, subtree: true });
      espelho();

      function ir(i, rolar) {
        at = Math.max(0, Math.min(n - 1, i));
        ps.forEach(function (p, k) { p.hidden = k !== at; });
        dots.querySelectorAll('[data-i]').forEach(function (b, k) {
          b.classList.toggle('is-on', k === at); b.classList.toggle('is-done', k < at);
          if (k === at) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        });
        cab.querySelector('.kit-pasos__n').textContent = T('paso', 'Paso') + ' ' + (at + 1) + ' ' + T('de', 'de') + ' ' + n;
        cab.querySelector('.kit-pasos__tit').textContent = ps[at].dataset.titulo || '';
        cab.querySelector('.kit-pasos__ayuda').textContent = ps[at].dataset.ayuda || '';
        pe.querySelector('.kit-pasos__ant').style.visibility = at ? '' : 'hidden';
        sig.style.display = te.style.display = at === n - 1 ? 'none' : '';   // .button tem display próprio e ignora [hidden]
        sig.textContent = (at === n - 2 ? T('fin', 'Ver resumen') : T('sig', 'Siguiente')) + ' →';
        box.dispatchEvent(new CustomEvent('kit:paso', { detail: { i: at, n: n } }));
        if (rolar) { var vh = parseFloat(getComputedStyle(fila).top) || 0, alvo = fila.getBoundingClientRect().top; if (alvo < vh || alvo > innerHeight * .6) scrollBy({ top: alvo - vh - 8, behavior: 'smooth' }); }
      }
      fila.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) ir(+b.dataset.i, true); });
      pe.querySelector('.kit-pasos__ant').addEventListener('click', function () { ir(at - 1, true); });
      sig.addEventListener('click', function () { ir(at + 1, true); });
      box.kitIr = ir;   // permite a uma secção saltar para um passo (ex.: campo obrigatório em falta)
      ir(0);
    });
  };

  /* 3) depois de «Añadir» fica na página e atualiza a bolha do carrinho (Section Rendering API, id do Dawn: cart-icon-bubble) */
  KitUI.adicionado = function (add, msg, txt, txtVer) {
    var r = raizLoja();
    add.disabled = false; msg.textContent = txt + ' ';
    var a = document.createElement('a'); a.href = r + 'cart'; a.textContent = (txtVer || 'Ver carrito') + ' →'; msg.appendChild(a);
    fetch(r + '?sections=cart-icon-bubble').then(function (x) { return x.json(); }).then(function (s) {
      var el = document.getElementById('cart-icon-bubble'), h = s && s['cart-icon-bubble'];
      if (el && h) { var d = new DOMParser().parseFromString(h, 'text/html').getElementById('shopify-section-cart-icon-bubble'); if (d) el.innerHTML = d.innerHTML; }
    }).catch(function () {});
  };

  /* propriedades a partir dos campos name="properties[...]" de um contentor (mesmo formato do formulário nativo da Shopify) */
  KitUI.props = function (el) {
    var o = {};
    el.querySelectorAll('[name^="properties["]').forEach(function (i) {
      if ((i.type === 'radio' || i.type === 'checkbox') && !i.checked) return;
      var v = (i.value || '').trim(); if (v) o[i.name.slice(11, -1)] = v;
    });
    return o;
  };

  /* 4) resumo da escolha por baixo de cada bolinha + barra fixa no telemóvel (total + botão principal [data-add]) */
  function valor(p) {
    var on = [].map.call(p.querySelectorAll('[aria-checked="true"]'), function (b) { return (b.getAttribute('data-v') || b.getAttribute('title') || b.textContent || '').trim(); }).filter(Boolean);
    var txt = [].map.call(p.querySelectorAll('input[type="text"], input[type="number"], select'), function (i) { return (i.value || '').trim(); }).filter(Boolean);
    return txt.concat(on).join(' · ');
  }
  function resumo(box) {
    var ps = [].filter.call(box.children, function (c) { return c.classList.contains('kit-paso'); });
    var dots = box.querySelectorAll('.kit-pasos__dots [data-i]'); if (!dots.length) return;
    ps.forEach(function (p, i) {
      var d = dots[i]; if (!d) return; var v = valor(p), s = d.parentElement.querySelector('.kit-pasos__val');
      if (!s) { s = document.createElement('span'); s.className = 'kit-pasos__val'; d.parentElement.appendChild(s); }
      s.textContent = v; s.title = (p.dataset.titulo || '') + (v ? ': ' + v : '');
    });
  }
  function barra(sec) {
    var add = sec.querySelector('[data-add]'), tot = sec.querySelector('[data-total]');
    if (!add || !tot || sec.querySelector('.kit-barra')) return;
    var b = document.createElement('div'); b.className = 'kit-barra';
    b.innerHTML = '<span class="kit-barra__tot"></span><button type="button" class="button kit-barra__btn"></button>';
    var box = sec.querySelector('[data-kit-pasos]'); box.parentElement.insertBefore(b, box.nextSibling);
    var t = b.querySelector('.kit-barra__tot'), btn = b.querySelector('.kit-barra__btn');
    function sync() { t.textContent = tot.textContent.trim() === '—' ? '' : tot.textContent.trim(); btn.textContent = add.textContent.trim(); btn.disabled = add.disabled; }
    btn.addEventListener('click', function () { add.click(); });
    if (window.MutationObserver) { new MutationObserver(sync).observe(tot, { childList: true, characterData: true, subtree: true }); new MutationObserver(sync).observe(add, { attributes: true, childList: true, subtree: true }); }
    sync();
  }
  function extras(raiz) {
    (raiz || document).querySelectorAll('[data-kit-pasos]:not([data-kit-extras])').forEach(function (box) {
      box.setAttribute('data-kit-extras', '');
      var sec = box.closest('section') || box.parentElement, r = function () { resumo(box); };
      sec.addEventListener('click', function () { setTimeout(r, 0); }); sec.addEventListener('input', r); sec.addEventListener('change', r); setTimeout(r, 300);
      if (box.hasAttribute('data-kit-barra')) barra(sec);
    });
  }

  pronto(KitUI.reveal);
  pronto(function (r) { KitUI.pasos(r); extras(r); });
})();
